import React from "react";

import { Box, Grid } from "@mui/material";
import {
  AccountCircleOutlined,
  EventAvailableOutlined,
  InfoOutlined,
  ReceiptLongOutlined,
} from "@mui/icons-material";
import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import Status from "components/Shared/Status";

import { localizeDateMed } from "utils/dateFormats";
import EmailTemplate from "./EmailTemplate";

const EmailTemplateDetail = ({ emailTemplateDetail, loadingEmailTemplate }) => {
  return !loadingEmailTemplate ? (
    <Box padding={3}>
      <Grid container spacing={5}>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <ReceiptLongOutlined color="primary" />}
            title={"Type"}
            subtitle={emailTemplateDetail?.for}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <EventAvailableOutlined color="primary" />}
            title="Created Date"
            subtitle={localizeDateMed(emailTemplateDetail?.createdAt)}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <AccountCircleOutlined color="primary" />}
            title="Updated Date"
            subtitle={localizeDateMed(emailTemplateDetail?.updatedAt)}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Active Status"
          >
            <Status isActive={emailTemplateDetail?.isActive} />
          </InformationTile>
        </Grid>

        <Grid item xs={12}>
          <InformationTile
            icon={() => <ReceiptLongOutlined color="primary" />}
            title={"Template"}
            subtitle={
              <EmailTemplate template={
                <div dangerouslySetInnerHTML={{ __html: emailTemplateDetail?.template }} />
              } />

            }
          />
        </Grid>

      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default EmailTemplateDetail;
